import { combineReducers } from 'redux';
import api from './api/reducer';
import sites from './sites/reducer';
import jobs from './jobs/reducer';
import trees from './trees/reducer';
import groups from './groups/reducer';
import map from './map/reducer';
import lookup from './lookup/reducer';

export default combineReducers({
  api,
  sites,
  jobs,
  trees,
  groups,
  map,
  lookup,
});
